import React from "react";
import './Gallery.scss'
import * as files from "./images/**/*";
import { importFiles } from "@randajan/simple-app/fs";

import ReactGallery from "react-photo-gallery";
import { Img } from "@randajan/jet-react/dom/img";

import { screen } from '@randajan/jet-react/base/screen';

const photos = Object.values(importFiles(files, {
  prefix:"./images/",
  trait:(ex, nm)=>{
    delete ex.default.aspectRatio;
    return ex.default
  }
}));

const Gallery = () => {

  screen.use();

  return (
    <section className="Gallery slab">
      <ReactGallery photos={photos} direction={"row"} margin={5} targetRowHeight={screen.height / 4} />
    </section>
  );
};

export default Gallery;
